import { createActions , createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions({
  resetRequest: ['payload'],
  resetSuccess: null,
  resetFailure: null,
  reset: null,
}, {
  prefix: "@PasswordReset/"
})

const INITIAL_STATE = {
  loading: false,
  success: false,
  error: false
}

const resetRequest = (state = INITIAL_STATE) => ({
  ...state,
  success: false,
  loading: true,
  error: false
})

const resetSuccess = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
  success: true,
  error: false
})

const resetFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
  success: false,
  error: true
})

const reset = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
  success: false,
  error: false
})

export default createReducer(INITIAL_STATE, {
  [Types.RESET_REQUEST]: resetRequest,
  [Types.RESET_SUCCESS]: resetSuccess,
  [Types.RESET_FAILURE]: resetFailure,
  [Types.RESET]: reset,
})